import { v1, toResult } from '@/infrastructure/api/v1/client';
import { myOrgMemberPatchBody } from '@/infrastructure/api/v1/mappers/orgMembers';
import type { UpdateOrgMemberData } from '@/types/orgTypes';

// Org tables are read-only on the generic route; these are the only org writes (lureo-docs#263)

/** Updates the signed-in user's own org membership. */
export async function updateMyOrgMember(changes: UpdateOrgMemberData): Promise<void> {
  const { error } = await toResult(v1.PATCH('/api/v1/orgs/me/member', { body: myOrgMemberPatchBody(changes) }));
  if (error) throw error;
}

/** Renames an org the signed-in user is a member of. */
export async function renameOrg(orgInstanceId: string, displayName: string): Promise<void> {
  const { error } = await toResult(v1.PATCH('/api/v1/orgs/{orgInstanceUniqueId}', {
    params: { path: { orgInstanceUniqueId: orgInstanceId } },
    body: { displayName },
  }));
  if (error) throw error;
}
